import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../redux/store';
import { selectAllSettings } from '../../../modules/settings/store/slice';

import { doCreateSetting, doGetSettings, doUpdateSetting } from '../../../modules/settings/store/thunk';
import { Button } from '../../ui/button';
import { Save } from 'lucide-react';
import { Switch } from '../../ui/switch';

export const Notifications = () => {
  const dispatch = useDispatch<AppDispatch>();
  const user = useSelector((state: RootState) => state.auth.user);

  const existing = useSelector((state: RootState) => selectAllSettings(state));
  const [newIssue, setNewIssue] = useState(false);
  const [newComment, setNewComment] = useState(false);
  const [newCriticallyDelayed, setNewCriticallyDelayed] = useState(false);
  const [newClaim, setNewClaim] = useState(false);

  useEffect(() => {
    dispatch(
      doGetSettings({
        category: 'notifications',
        userId: user.id,
      }),
    );
  }, []);

  const handleSave = async () => {
    const updates = [];

    updates.push({
      id: existing.find((e) => e.keyword === 'NEW_ISSUE')?.id || null,
      keyword: 'NEW_ISSUE',
      value: newIssue ? 'true' : 'false',
      group: 'NOTIFICATIONS',
      carrierId: user.carrierId || null,
      companyId: user.companyId || null,
      userId: user.id || null,
    });

    updates.push({
      id: existing.find((e) => e.keyword === 'NEW_ISSUE_COMMENT')?.id || null,
      keyword: 'NEW_ISSUE_COMMENT',
      value: newComment ? 'true' : 'false',
      group: 'NOTIFICATIONS',
      carrierId: user.carrierId || null,
      companyId: user.companyId || null,
      userId: user.id || null,
    });
    updates.push({
      id: existing.find((e) => e.keyword === 'NEW_CRITICALLY_DELAYED')?.id || null,
      keyword: 'NEW_CRITICALLY_DELAYED',
      value: newCriticallyDelayed ? 'true' : 'false',
      group: 'NOTIFICATIONS',
      carrierId: user.carrierId || null,
      companyId: user.companyId || null,
      userId: user.id || null,
    });
    updates.push({
      id: existing.find((e) => e.keyword === 'NEW_CLAIM')?.id || null,
      keyword: 'NEW_CLAIM',
      value: newClaim ? 'true' : 'false',
      group: 'NOTIFICATIONS',
      carrierId: user.carrierId || null,
      companyId: user.companyId || null,
      userId: user.id || null,
    });

    try {
      await Promise.all(
        updates.map(async (u) => {
          if (u.id && u.value) {
            // if it existed and has a value => update it
            await dispatch(doUpdateSetting(u));
          } else if (u.value) {
            // if it didn't exist => create it
            await dispatch(doCreateSetting(u));
          }
        }),
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (existing) {
      setNewIssue(existing.find((e) => e.keyword === 'NEW_ISSUE')?.value === 'true');
      setNewComment(existing.find((e) => e.keyword === 'NEW_ISSUE_COMMENT')?.value === 'true');
      setNewCriticallyDelayed(existing.find((e) => e.keyword === 'NEW_CRITICALLY_DELAYED')?.value === 'true');
      setNewClaim(existing.find((e) => e.keyword === 'NEW_CLAIM')?.value === 'true');
    }
  }, [existing]);

  return (
    <div className="m-6">
      <h1 className="text-xl font-bold">Notifications for</h1>
      <p>
        Send me a notification on <em>{user.email}</em> in the following events
      </p>

      <div className="mt-8 flex flex-col space-y-4">
        <div className="flex justify-between rounded-lg border p-3 shadow-sm items-center w-[500px]">
          <div>
            <h3 className="font-bold ">New Issue</h3>
            <p>Receive a notification when a new issue was created and assigned to you</p>
          </div>
          <Switch id="new-issue" checked={newIssue} onCheckedChange={setNewIssue} />
        </div>
        <div className="flex justify-between rounded-lg border p-3 shadow-sm items-center w-[500px]">
          <div>
            <h3 className="font-bold ">New comment</h3>
            <p>Receive a notification when an existing issue gets a new comment addressed to you</p>
          </div>

          <Switch id="new-comment" checked={newComment} onCheckedChange={setNewComment} />
        </div>
        <div className="flex justify-between rounded-lg border p-3 shadow-sm items-center w-[500px]">
          <div>
            <h3 className="font-bold ">New critically delayed order</h3>
            <p>Receive a notification when an order is recognised as critically delayed</p>
          </div>

          <Switch id="new-comment" checked={newCriticallyDelayed} onCheckedChange={setNewCriticallyDelayed} />
        </div>
        <div className="flex justify-between rounded-lg border p-3 shadow-sm items-center w-[500px]">
          <div>
            <h3 className="font-bold ">New Claim</h3>
            <p>Receive a notification when a new claim is filed</p>
          </div>

          <Switch id="new-comment" checked={newClaim} onCheckedChange={setNewClaim} />
        </div>
      </div>
      <div className="w-[500px] flex justify-end mt-8 gap-4">
        <Button className="px-8" onClick={handleSave}>
          <Save /> Save
        </Button>
      </div>
    </div>
  );
};
